import { wrapReducer } from "@client/content/lib/helper";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions } from "./actions";
import { type KnowledgeBase } from "./types";

const reducer = (state: KnowledgeBase.State, action: ReduxAction<any>): KnowledgeBase.State => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: "Loading"
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.InitSuccess: {
      const { articles, categories } = action.data as KnowledgeBase.Api.InitResponse;
      return {
        ...state,
        articles,
        categories,
        status: "Ready"
      };
    }
    case Actions.SetActiveItem: {
      return {
        ...state,
        activeItem: action.data.activeItem as KnowledgeBase.View.ActiveItem
      };
    }
    case Actions.LoadContentBegin: {
      return {
        ...state,
        status: "Loading"
      };
    }
    case Actions.LoadContentFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.LoadContentSuccess: {
      return {
        ...state,
        activeItem: {
          ...state.activeItem,
          content: action.data
        } as KnowledgeBase.View.ActiveArticle,
        status: "Ready"
      };
    }

    default:
      return state;
  }
};

export const defaultState: KnowledgeBase.State = {
  activeItem: null,
  articles: [],
  categories: [],
  id: "",
  status: "None"
};
export const previewState: KnowledgeBase.State = {
  activeItem: null,
  articles: [
    {
      articleCategoryId: "dummy",
      articleId: "",
      sortOrder: 1,
      title: "Dummy"
    }
  ],
  categories: [
    {
      articleCategoryId: "dummy",
      name: "Dummy",
      parentArticleCategoryId: null,
      sortOrder: 1
    }
  ],
  id: "",
  status: "Ready"
};
export default wrapReducer<KnowledgeBase.State>({ defaultState, reducer, previewState });
